import { Res, PrintPreviewDTO, PrintTemplateType } from 'core/api';
import * as React from 'react';
import { Modal } from 'core/ui-next/modal';
import { BackActionButton, PhoneDeviceActionButton } from './ActionButton';
import { PosScreen } from './PosScreen';
import { Header } from './Header';
import { Content } from './Content';
import { Footer } from './Footer';
import { PhoneOnly } from './PhoneOnly';
import { Filler } from './Filler';
import { Box, VStack } from '@chakra-ui/react';
import { TemplatePrintPreview } from 'core/ui';
import { ScreenSize } from './ScreenSize';

type Props = {
	title: string,
	image: SvgIcon,
	preview: PrintPreviewDTO,
	onPrint: () => Promise<Result>
} & Modal.Actions<void>

export default function ShowPreviewScreen(props: Props) {

	const { title, image, preview, cancel } = props;

	const onPrint = async () => {
		const result = await props.onPrint();
		if (result.ok)
			props.close();
	};

	const getPreviewSize = (): ScreenSize => {
		if (preview.TemplateType === PrintTemplateType.EscPos) {
			if (preview.EscPosNumberOfColumns > 48) {
				return { width: 550, height: 690 };
			}
			return { width: 420, height: 690 };
		}
		return 'medium';
	};

	const onCancel = React.useCallback(async () => cancel(), [cancel]);

	return (
		<PosScreen screenId={'SHOW_PREVIEW'} size={getPreviewSize()} useKeyPad={false}>
			<Header title={title} onClose={cancel} />
			<Content>
				<VStack width={'full'} height={'full'}>
					<Box border={'1px solid #ccc'} overflow={'auto'}>
						<TemplatePrintPreview preview={preview} />
					</Box>
				</VStack>
			</Content>
			<Footer>
				<PhoneOnly>
					<BackActionButton action={onCancel} />
				</PhoneOnly>
				<Filler />
				<PhoneDeviceActionButton title={Res.Common.PRINT_BTN()} image={image} action={onPrint} />
			</Footer>
		</PosScreen>
	);
}